module.exports = __webpack_public_path__ + "static/media/paper27.aeb65be2.jpg";